import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { matchPath, NavLink, useLocation, useMatch, useResolvedPath } from "react-router-dom";
import { shallow } from "zustand/shallow";
import Menu from "./../../config/app-menu.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuthStore } from "../../stores/auth";

function NavItem({ menu, ...props }) {
  const resolved = useResolvedPath(menu.path);
  const match = useMatch({ path: resolved.pathname });

  const location = useLocation();
  const match2 = matchPath({ path: menu.path, end: false }, location.pathname);

  const icon = menu.icon && (
    <div className="menu-icon">
      <i className={menu.icon}></i>
    </div>
  );
  const img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  const caret = menu.children && !menu.badge && <div className="menu-caret"></div>;
  const label = menu.label && <span className="menu-label ms-5px">{menu.label}</span>;
  const badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  const highlight = menu.highlight && <i className="fa fa-paper-plane text-theme"></i>;
  const title = menu.title && (
    <div className="menu-text">
      {menu.title} {label} {highlight}
    </div>
  );

  return (
    <div className={"menu-item" + (match || match2 ? " active" : "") + (menu.children ? " has-sub" : "")}>
      <NavLink className="menu-link" to={menu.path} {...props}>
        {img} {icon} {title}
        {caret} {badge}
      </NavLink>

      {menu.children && (
        <div className="menu-submenu">
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarNav() {
  const { t } = useTranslation();
  const [hasRole] = useAuthStore((state) => [state.hasRole], shallow);
  const menus = Menu(t);
  return (
    <AppSettings.Consumer>
      {({ toggleAppSidebarMobile }) => (
        <Fragment>
          <div className="menu">
            <div className="menu-header">Navigation</div>
            {menus
              .filter((m) => m.roles.some(hasRole))
              .map((menu, i) =>
                menu.divider ? (
                  <div key={i} className="menu-header">
                    {menu.title}
                  </div>
                ) : (
                  <NavItem key={i} menu={menu} onClick={toggleAppSidebarMobile} />
                ),
              )}
          </div>
        </Fragment>
      )}
    </AppSettings.Consumer>
  );
}

export default SidebarNav;
